<template>
    <div class="page addcredit pt-5 pb-3">
        <div class="container descktopMediaBox">
            <button class="my-5 smlBtn" @click="$router.go(-1)" style="max-width: 180px"> back</button>
        </div>
        <div class="container">
            <h2 class="mt-4">Payment Cards Accepted: Visa and Mastercard</h2>
        </div>
        <div class="h-100">
            <form style="display:none;" id="aNetForm" :action='url'
                  target="aNetIframe" method="post">
                <input type="text" name="token" :value="authorizeNetToken"/>
            </form>
            <iframe style="width:100%; height:100%;" name="aNetIframe" id="aNetIframe" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import $ from "jquery";

    export default {
        name: "AddCredit",
        data() {
            return {
                authorizeNetToken: null,
                url: null,
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Add Credit/Debit Card", showBackButton: true, showBag: false}, {root: true});
            if (this.gatewayInfo) {
                this.getPaymentURL();
                //console.log(this.gatewayInfo)
            }

        },
        methods: {
            getPaymentURL() {
                const href = "http://localhost:8080" //window.location.href;
                let url = ""
                if (this.user) {
                    url = `/auth/gateways/${this.gatewayInfo.gateway_id}/users/${this.user.member_id}/payment_settings?url=${href}`
                } else {
                    url = `/unauth/gateways/${this.gatewayInfo.gateway_id}/payment_settings?url=${href}`
                }

                axios.get(url).then(res => {
                    //console.log(res);
                    if (res.data.token) {
                        this.authorizeNetToken = res.data.token;
                        if (this.user) {
                            this.url = res.data.live ? "https://accept.authorize.net/customer/addPayment" : "https://test.authorize.net/customer/addPayment";
                        }else{
                            this.url = res.data.is_live ? "https://accept.authorize.net/customer/addPayment" : "https://test.authorize.net/customer/addPayment";
                        }
                        
                        this.$nextTick(() => {
                            $('#aNetForm').submit();
                        })
                        if (res.data.guest_id) {
                            this.$store.commit("shared/setGuestId", res.data.guest_id)
                            this.giftCardData.purchaser.guest_id = res.data.guest_id
                        }
                    }
                })
            }
        },
        computed: {
            gatewayInfo() {
                return this.$store.state.shared.gatewayInfo;
            },
            giftCardData() {
                return this.$store.state.giftcard.giftCardData;
            }
        },
        destroyed() {
            let url = "";
            if (this.user) {
                url = `/auth/gateways/${this.gatewayInfo.gateway_id}/users/${this.user.member_id}/credit_cards`
            } else {
                url = `/unauth/gateways/${this.gatewayInfo.gateway_id}/guests/${this.$store.state.shared.guest_id}/credit_cards`
            }
            axios.post(url, {
                'token': '',
                'temp': 0
            }).then(res => {
                this.$store.commit("cart/updateCartDate");
            })
        },
        watch: {
            gatewayInfo(val) {
                if (val) {
                    this.getPaymentURL();
                }
            }
        }
    }
</script>
